import script from "./SearchHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchHistory.vue?vue&type=script&setup=true&lang=js"

import "./SearchHistory.vue?vue&type=style&index=0&id=71101bfb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71101bfb"]])

export default __exports__